module.exports = __webpack_public_path__ + "static/media/copyIcon.c9ac0333.svg";